module.exports = __webpack_public_path__ + "play.4ea0f444.png";